// CONFIG AND EXTENSION SETTING
/*
For default config and extensions (and available options) available to
`setConfig()`, see the file `docs/tutorials/ConfigOptions.md`
*/

import './editor/jquery.min.js';
import './editor/dialogs/index.ts';
import Editor from './editor/Editor';
import 'bootstrap/dist/js/bootstrap.js';
import './style/style.scss';
import { isChrome, isEdge, isGecko, isMac, isOpera, isSafari, isWindows } from './common/browser.js';
// Registers on _zaa_services and starts tracking document changes for Blazor. Not exported from services/index.ts,
// as it depends on svgcanvas, which itself imports services.
import './services/document-sync-service';

window['_initZenAutoArt'] = (serviceRef) => {
    Editor.Create(serviceRef).then(svgEditor => {

        svgEditor.setConfig(
            {
                // Indicate pref settings here if you wish to allow user storage or URL
                //   settings to be able to override your default preferences (unless
                //   other config options have already explicitly prevented one or the
                //   other)
            },
            { allowInitialUserOverride: true }
        );

        svgEditor.setConfig({
            // User extensions can be loaded from explicit paths in addition to the
            // built-in functionality included in the main bundle.
            userExtensions: [
                //'../ext-paneldesigner/ext-paneldesigner.js'
            ],

            // OTHER CONFIG
            // canvasName: 'default',
            // canvas_expansion: 3,
            initFill: {
                color: '000000',
                opacity: 1
            },
            initStroke: {
                width: 5,
                color: '000000',
                opacity: 1
            },
            // initOpacity: 1,
            // initTool: 'select',
            // exportWindowType: 'new', // 'same'
            // wireframe: false,
            showlayers: true,
            // no_save_warning: false,
            // PATH CONFIGURATION
            // imgPath: 'images/',
            /*
            Uncomment the following to allow at least same domain (embedded) access,
            including `file:///` access.
            Setting as `['*']` would allow any domain to access but would be unsafe to
            data privacy and integrity.
            */
            // May be 'null' (as a string) when used as a `file:///` URL
            // allowedOrigins: [location.origin || 'null'],
            // DOCUMENT PROPERTIES
            // dimensions: [640, 480],
            // EDITOR OPTIONS
            // gridSnapping: false,
            // gridColor: '#000',
            baseUnit: 'mm',
            snappingStep: 1,
            // showRulers: true,
            // EXTENSION-RELATED (GRID)
            // showGrid: false, // Set by ext-grid.js
            // Set dynamically within locale.js if not previously set
            // lang: '',
            // Will default to 's' if the window height is smaller than the minimum
            //  height and 'm' otherwise
            // iconsize: '',
            /**
            * When showing the preferences dialog, svg-editor.js currently relies
            * on `curPrefs` instead of `svgEditor.pref`, so allowing an override for
            * `bkgd_color` means that this value won't have priority over block
            * auto-detection as far as determining which color shows initially
            * in the preferences dialog (though it can be changed and saved).
            */
            bkgd_color: window.localStorage.getItem("bkgd_color") ?? 'chessboard',
            // bkgd_url: 'url(data:image/gif;base64,R0lGODlhEAAQAIAAAP///9bW1iH5BAAAAAAALAAAAAAQABAAAAIfjG+gq4jM3IFLJgpswNly/XkcBpIiVaInlLJr9FZWAQA7)',
            // img_save: 'embed',
            // Only shows in UI as far as alert notices
            // save_notice_done: false,
            // export_notice_done: false
            mouseWheelZoomEnabled: (window.localStorage.getItem("mouseWheelZoomEnabled")?.toString() ?? "true") === "true",
            clickThroughGroups: (window.localStorage.getItem("clickThroughGroups")?.toString() ?? "false") === "true",
        });

        // Variable XDOMAIN below is created by Rollup for the Xdomain build (see rollup.config.js)
        try { // try clause to avoid js to complain if XDOMAIN undefined
            if (window['XDOMAIN']) {
                svgEditor.setConfig({
                    allowedOrigins: ['*']
                });
                console.info('xdomain config activated');
            }
        } catch (error) {/* empty fn */ }

        // Add body classes to add CSS fixes
        if (isMac()) {
            document.body.classList.add("mac");
        } else if (isWindows()) {
            document.body.classList.add("windows");
        }

        if (isEdge()) { // Chromium Edge uses Edg/, not Edge/
            document.body.classList.add("edge");
        } else if (isChrome()) {
            document.body.classList.add("chrome");
        } else if (isSafari()) {
            document.body.classList.add("safari");
        } else if (isGecko()) {
            document.body.classList.add("firefox");
        } else if (isOpera()) {
            document.body.classList.add("opera");
        }
    });
}

if(window['_initZenAutoArtCalled'] === true) {
    // We were called before JS loaded, so invoke immediately.
    delete window['_initZenAutoArtCalled'];
    const serviceRef = window['_initZenAutoArtServiceRef'];
    window['_initZenAutoArt'](serviceRef);
}